import { IModifierGroupContext, IFilterValues } from './modifierGroupContext';

export enum ModifierGroupActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_MODIFIER_GROUPS = 'SET_MODIFIER_GROUPS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	TOGGLE_REMEMBER_MY_CHOICE = 'TOGGLE_REMEMBER_MY_CHOICE',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_ASSIGN_RESTAURANTS = 'SET_ID_FOR_ASSIGN_RESTAURANTS',
	SET_ID_FOR_EDIT_RESTAURANT_PROPERTIES = 'SET_ID_FOR_EDIT_RESTAURANT_PROPERTIES',
	SET_ID_FOR_EDIT_MODIFIERS_TEMPLATE = 'SET_ID_FOR_EDIT_MODIFIERS_TEMPLATE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface IRefetchData {
	type: ModifierGroupActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IModifierGroupContext['needRefetchData'];
	};
}

interface ISetModifierGroups {
	type: ModifierGroupActionTypes.SET_MODIFIER_GROUPS;
	payload: {
		modifierGroups: IModifierGroupContext['modifierGroups'];
		typeOfModalWindow: IModifierGroupContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: ModifierGroupActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IModifierGroupContext['searchString'];
	};
}

interface IToggleRememberMyChoice {
	type: ModifierGroupActionTypes.TOGGLE_REMEMBER_MY_CHOICE;
	payload: {
		rememberMyChoice: IModifierGroupContext['rememberMyChoice'];
	};
}

interface ISetIDCustomer {
	type: ModifierGroupActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IModifierGroupContext['IDSelectedCustomer'];
		modifierGroups: IModifierGroupContext['modifierGroups'];
	};
}

interface ISetIDRestaurant {
	type: ModifierGroupActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IModifierGroupContext['IDSelectedRestaurant'];
	};
}

interface IResetSelectedControls {
	type: ModifierGroupActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: ModifierGroupActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IModifierGroupContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: ModifierGroupActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IModifierGroupContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: ModifierGroupActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IModifierGroupContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: ModifierGroupActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IModifierGroupContext['IDForDeletion'];
		typeOfModalWindow: IModifierGroupContext['typeOfModalWindow'];
	};
}

interface ISetIDForAssignRestaurant {
	type: ModifierGroupActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS;
	payload: {
		IDForAssignRestaurants: IModifierGroupContext['IDForAssignRestaurants'];
		typeOfModalWindow: IModifierGroupContext['typeOfModalWindow'];
	};
}

interface ISetIDForEditRestaurantProperties {
	type: ModifierGroupActionTypes.SET_ID_FOR_EDIT_RESTAURANT_PROPERTIES;
	payload: {
		IDForEditRestaurantProperties: IModifierGroupContext['IDForEditRestaurantProperties'];
		typeOfModalWindow: IModifierGroupContext['typeOfModalWindow'];
	};
}

interface ISetIDForEditModifiersTemplate {
	type: ModifierGroupActionTypes.SET_ID_FOR_EDIT_MODIFIERS_TEMPLATE;
	payload: {
		IDForEditModifiersTemplate: IModifierGroupContext['IDForEditModifiersTemplate'];
		typeOfModalWindow: IModifierGroupContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ModifierGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IModifierGroupContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: ModifierGroupActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TModifierGroupAction =
	| IRefetchData
	| ISetModifierGroups
	| IChangeSearchString
	| IToggleRememberMyChoice
	| ISetIDCustomer
	| ISetIDRestaurant
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForAssignRestaurant
	| ISetIDForEditRestaurantProperties
	| ISetIDForEditModifiersTemplate
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
